import { useQuery } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';
import type { ICandidateProfessionalEntity, IGetCandidateProfessionalPayload } from '../types';
import { useEffect } from 'react';
import { showErrorMessage } from '~/domain/utils';

interface IUseGetCandidateProfessionalOptions {
  enabled?: boolean;
}

export const getCandidateProfessionalQueryKey = (payload: IGetCandidateProfessionalPayload) => [
  'GET_CANDIDATE_PROFESSIONAL',
  payload.postingId,
  payload.professionalId,
];

export const useGetCandidateProfessional = (
  payload: IGetCandidateProfessionalPayload,
  options?: IUseGetCandidateProfessionalOptions,
) => {
  const { data, error, isFetching, isLoading, isError } = useQuery<
    ICandidateProfessionalEntity,
    Error
  >({
    queryKey: getCandidateProfessionalQueryKey(payload),
    queryFn: () => PermanentJobsService.getCandidateProfessional(payload),
    retry: false,
    enabled: options?.enabled ?? true,
  });

  useEffect(() => {
    if (error) {
      showErrorMessage({ error });
    }
  }, [error]);

  return {
    data,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
